import { getToken } from "./auth.ts";
import type { AppDetail, OverviewResponse, TimeRange } from "./types.ts";

async function get<T>(path: string): Promise<T> {
  const token = await getToken();
  const res = await fetch(path, {
    headers: token ? { authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error(`${path} → ${res.status}`);
  return (await res.json()) as T;
}

export const fetchOverview = () => get<OverviewResponse>("/api/overview");
export const fetchDetail = (id: string, range: TimeRange = "3h") =>
  get<AppDetail>(`/api/app/${encodeURIComponent(id)}?range=${range}`);

async function post(path: string, body?: unknown): Promise<void> {
  const token = await getToken();
  const res = await fetch(path, {
    method: "POST",
    headers: { "content-type": "application/json", ...(token ? { authorization: `Bearer ${token}` } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) throw new Error(`${path} → ${res.status}`);
}

export const ackAlarm = (name: string) => post(`/api/alarms/${encodeURIComponent(name)}/ack`);
export const snoozeAlarm = (name: string, hours = 4) => post(`/api/alarms/${encodeURIComponent(name)}/snooze`, { hours });
